module.exports = __webpack_public_path__ + "fonts/SourceSans3-Regular.c69f965.ttf";